<template>
    <div class="container" v-bind:style="{ height: '100vh' }">
        <div v-if="!this.message" class="d-flex flex-column justify-content-center align-items-center" v-bind:style="{ height: '100%' }">
            <Icon icon="mdi:check-circle-outline" v-bind:style="{ color: this.$THEME.backgroundColor, fontSize: '150px' }"/>
            <div class="text-center mt-3">
                <h1 v-bind:style="{ color: this.$THEME.backgroundColor, fontSize: '24px', fontWeight: 'bold' }">เปิดใช้งาน Wallet สำเร็จ</h1>
                <p>กรุณาเติมเงินเพื่อใช้งานระบบ</p>
            </div>
            <b-button class="mt-3 w-50" block variant="primary" @click="backHomePage">กลับสู่หน้าหลัก</b-button>
        </div>
        <div v-if="this.message" class="d-flex flex-column justify-content-center align-items-center" v-bind:style="{ height: '100%' }">
            <Icon icon="mdi:cancel-circle-outline" v-bind:style="{ color: 'red', fontSize: '150px' }"/>
            <div class="text-center mt-3">
                <h1 v-bind:style="{ color: 'red', fontSize: '24px', fontWeight: 'bold' }">เปิดใช้งาน Wallet ไม่สำเร็จ</h1>
                <p>{{ this.message }}</p>
            </div>
            <b-button class="mt-3 w-50" block variant="primary" @click="backHomePage">กลับสู่หน้าหลัก</b-button>
        </div>
    </div>
</template>

<script>
    import lsm from '@/constants/LocalStorageManagement'
    import { fetchWalletMetadataToLocalStorage } from "@/axios/walletPayment.js"

    export default {
        data() {
            return {
                message: ''
            }
        },
        mounted() {
            const token = this.$route.query.token
            const accessToken = localStorage.getItem('access_token')

            if (!token) {
                this.message = 'Token not found'
                return
            }

            if (!accessToken) {
                this.message = 'Access token not found'
                return
            }

            const decoded = lsm._jwtDecode(token)
            const { email } = decoded

            if (!email) {
                this.message = 'Invalid decoded token'
                return
            }

            const url = `${process.env.VUE_APP_API}/shop_wallet/verified`

            this.$http.post(url, {
                email,
                verified: 1
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Token: accessToken
                }
            }).then(async (res) => {
                if (!res.data.status) {
                    const { notices } = res.data.error

                    Object.values(notices).forEach(notice => {
                        this.message += notice.pop()
                    })
                } else {
                    await fetchWalletMetadataToLocalStorage(true)
                }
            }).catch(err => {
                this.message = err.message
            })
        },
        methods: {
            backHomePage() {
                this.$router.push('/')
            }
        }
    }
</script>